(() => {
  const formId = 'RyTNEv';
  const startKey = 'romel_newsletter_visit_start';
  const dismissKey = 'romel_newsletter_dismissed_v2';
  const teaserKey = 'romel_newsletter_teaser_dismissed_v2';
  const openedKey = 'romel_newsletter_opened_v3';
  const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const body = document.body;
  const previewPopup = new URLSearchParams(location.search).get('newsletter_preview') === '1';
  const protectedPage = body.matches('.template-product,.template-cart');
  const stored = Number(read(startKey));
  const started = stored > 0 ? stored : Date.now();
  if (!stored) write(startKey, String(started));
  body.classList.toggle('romel-newsletter-dismissed', !previewPopup && Boolean(read(dismissKey)));
  body.classList.toggle('romel-teaser-dismissed', Boolean(read(teaserKey)));
  const dismiss = () => {
    body.classList.add('romel-newsletter-dismissed');
    body.classList.remove('klaviyo-prevent-body-scrolling');
    write(dismissKey, '1');
  };
  window.addEventListener('klaviyoForms', event => {
    if (!event.detail || event.detail.formId !== formId) return;
    if (event.detail.type === 'open' || event.detail.type === 'submit') write(openedKey, '1');
    if (event.detail.type === 'open') body.classList.remove('romel-newsletter-dismissed');
    if (event.detail.type === 'close') dismiss();
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[role="dialog"][aria-label="ROMEL back-in-stock email alert"]')) return;
    if (event.isTrusted && event.target.closest('[data-testid="animated-teaser"] button[aria-label="Close teaser"]')) {
      body.classList.add('romel-teaser-dismissed');
      write(teaserKey, '1');
      dismiss();
      return;
    }
    if (event.target.closest('[data-testid="animated-teaser"]')) {
      body.classList.remove('romel-newsletter-dismissed');
      return;
    }
    if (event.target.closest('[data-testid="modal-form-container"] button[aria-label="Close dialog"]')) dismiss();
  }, true);
  window.setTimeout(() => {
    body.classList.add('romel-newsletter-ready');
    if (protectedPage || (!previewPopup && (read(dismissKey) || read(openedKey)))) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    write(openedKey, '1');
  }, previewPopup ? 1800 : Math.max(0, 30000 - (Date.now() - started)));
})();
/* Presentation only: preserve Klaviyo fields, submission and consent behaviour. */
(() => {
 const enhance = () => {
  document.querySelectorAll('[data-testid="modal-form-container"]').forEach(panel => {
   const title = Array.from(panel.querySelectorAll('span')).find(el => el.textContent.trim() === 'Join the ROMEL list');
   if (!title || panel.classList.contains('romel-signup-enhanced')) return;
   panel.classList.add('romel-signup-enhanced');
   title.classList.add('romel-signup-title');
   const eyebrow = document.createElement('div');
   eyebrow.className = 'romel-signup-eyebrow';
   eyebrow.textContent = 'YOUR INVITATION TO ROMEL';
   title.closest('p').before(eyebrow);
   const copy = Array.from(panel.querySelectorAll('span')).find(el => el.textContent.trim() === 'New collections, early access and exclusive offers.');
   if (copy) {
    copy.textContent = 'A little something worth opening. Be first to discover new collections, enjoy early access and receive exclusive offers.';
    copy.classList.add('romel-signup-copy');
   }
  });
 };
 new MutationObserver(enhance).observe(document.body, {childList:true, subtree:true});
 enhance();
})();